import Vue from 'vue'
import Vuex from 'vuex'

import browser from './browser'
import wechat from './wechat'
import app from './app' 
import question from './question'
import swipeup from './swipeup'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    browser: browser,
    wechat: wechat,
    app: app,
    question: question,
    swipeup: swipeup
  },
  strict: process.env.NODE_ENV !== 'production',
})

if (module.hot) {
  module.hot.accept(['./browser', './wechat', './app', './question', './swipeup'], () => {
    store.hotUpdate({
      modules: {
        browser: require('./browser'),
        wechat: require('./wechat'),
        app: require('./app'),
        question: require('./question'),
        swipeup: require('./swipeup')
      },
    })
  })
}

export default store
